import { render, staticRenderFns } from "./AdminPredefinedAnswerTableRow.vue?vue&type=template&id=32d86eb9&"
import script from "./AdminPredefinedAnswerTableRow.vue?vue&type=script&lang=ts&"
export * from "./AdminPredefinedAnswerTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports